import $ from "jquery";
import { userProfile } from "@/helpers/user";
import ProfileImageInput from "@/components/domain/my-profile/my-profile-form/profile-image-input.vue";
import { validateNonEmptyRequiredInputs } from "@/helpers/form";
import CompanyProfileForm from "@/components/domain/my-profile/company-profile-form/company-profile-form.vue";
import { mountVueComponent } from "@/app";

$(".member-profile-image-input").each(function () {
  const $this = $(this);
  let index = 0;

  $this.hide();
  $(
    `<div id="member-profile-image-input-wrapper-${index}"></div>`
  ).insertBefore($this);
  mountVueComponent(
    ProfileImageInput,
    `#member-profile-image-input-wrapper-${index}`,
    { input: $this[0] }
  );

  index++;
});

$("#post-91415 input").on("change", function () {
  const $this = $(this);
  const $form = $this.parents("form");

  validateNonEmptyRequiredInputs($form);
});

$(() => {
  $("#post-91415 form").each(function () {
    const $this = $(this);

    validateNonEmptyRequiredInputs($this);
  });
});

mountVueComponent(CompanyProfileForm, "#my-profile-companies");

$(async () => {
  if (!window.location.href.includes("members-area/my-profile")) {
    return;
  }

  const user = await userProfile();

  $('input[name="profiletitle"]').val(user.title);
  $('input[name="profilename"]').val(user.full_name);
  $('input[name="profilejobtitle"]').val(user.position);
  $('input[name="profilecountry"]').val(user.country);
  $('input[name="profilephone"]').val(user.phone);
  $('input[name="profileemail"]').val(user.email);

  if (user.profile_image) {
    $(".profile-image").attr("src", user.profile_image);
    $(".profile-image").show();
  }

  $("form[action=\"/members-area/my-profile/#wpcf7-f91417-p91415-o1\"] input").on("blur", function() {
    const $this = $(this);
    const $form = $this.parents("form.wpcf7-form");
    const $inputWrappers = $form.find(".wpcf7-form-control-wrap");
    const $submit = $form.find("#btSubmit");

    if ($form.length === 0 || $submit.length === 0) {
      return;
    }

    setTimeout(() => {
      let errors = 0;

      $inputWrappers.each(function() {
        const $wrapper = $(this);
        const $input = $wrapper.find("input");

        if (["file", "hidden"].includes($input.attr("type"))) {
          return;
        }

        if ($wrapper.hasClass("error") || !$input.val()) {
          errors++;
        }
      });

      $submit.toggleClass("disabled", errors > 0);
    }, 300);
  });
});
